import { Workbox } from 'workbox-window';

export default function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    console.log('[SW] Registering service worker...');
    const wb = new Workbox('/sw.js');
    let waitingSW = null;
    
    // Function to notify the app that an update is available
    const showUpdateUI = () => {
      console.log('[SW] Dispatching UPDATE_AVAILABLE event');
      
      // Dispatch a custom event that our React component can listen to
      window.dispatchEvent(
        new CustomEvent('sw-update', {
          detail: { type: 'UPDATE_AVAILABLE' }
        })
      );
    };
    
    // Forward all messages from the service worker to the application
    wb.addEventListener('message', (event) => {
      console.log('[SW] Message from service worker received:', event.data);
      
      // Forward all messages to the application via our custom event
      window.dispatchEvent(
        new CustomEvent('sw-message', {
          detail: event.data
        })
      );
      
      // Also send specific event for progress updates for better reliability
      if (event.data.type === 'INSTALL_PROGRESS') {
        console.log(`[SW] Progress update: ${event.data.progress}%`);
        window.dispatchEvent(
          new CustomEvent('sw-progress', {
            detail: { progress: event.data.progress }
          })
        );
      }
      
      // Handle update activation - this can trigger the page reload
      if (event.data.type === 'UPDATE_ACTIVATED') {
        console.log('[SW] Update activated, will reload page soon');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    });
    
    // Listen for the waiting event which indicates an update is available
    wb.addEventListener('waiting', (event) => {
      console.log('[SW] New service worker waiting.');
      waitingSW = wb.waiting || event.sw;
      showUpdateUI();
    });
    
    // Listen for controlling event
    wb.addEventListener('controlling', () => {
      console.log('[SW] New service worker is now controlling the page.');
      // We'll let the message handler take care of the reload
    });
    
    // Listen for errors
    wb.addEventListener('error', (event) => {
      console.error('[SW] Service worker error:', event);
    });
    
    // Register the service worker
    wb.register()
      .then((registration) => {
        console.log('[SW] Registered successfully', registration);
        
        // Check if there's already a waiting service worker
        if (registration.waiting) {
          console.log('[SW] Detected waiting SW on init.');
          waitingSW = registration.waiting;
          showUpdateUI();
        }
        
        // Update check function
        const checkForUpdates = () => {
          console.log('[SW] Checking for updates...');
          registration.update()
            .catch(err => console.error('[SW] Update check failed:', err));
        };
        
        // In development, always update
        if (import.meta.env.MODE === 'development') {
          checkForUpdates();
        }
        
        // Periodically check for updates in production
        if (import.meta.env.MODE === 'production') {
          // Check for updates every 60 minutes
          setInterval(checkForUpdates, 60 * 60 * 1000);
        }
      })
      .catch(error => {
        console.error('[SW] Registration failed:', error);
      });
      
    // Allow UI to trigger skipWaiting
    window.__SW_SKIP_WAITING__ = () => {
      if (waitingSW) {
        console.log('[SW] Sending SKIP_WAITING message...');
        waitingSW.postMessage({ type: 'SKIP_WAITING' });
      } else {
        console.warn('[SW] No waiting service worker found');
      }
    };
  } else {
    console.warn('[SW] Service workers not supported');
  }
}